import { lngRole, lngStatus, lngSlot } from '../sys_strings';
import { tokens } from '../tokens';
import { appStr } from '../app_strings';

const itemRole = {
  [lngRole.teacher]: 'Teacher',
  [lngRole.officer]: 'Officer',
  [lngRole.accountant]: 'Accountant',
  [lngRole.leader]: 'Leader',
  [lngRole.administrator]: 'Admin',
  [lngRole.seller]: 'Seller',
  [lngRole.censor]: 'Censor',
  [lngRole.highest]: 'Prototype',
};

const itemStatus = {
  [lngStatus.new]: 'New',
  [lngStatus.pending]: 'Pending',
  [lngStatus.confirmed]: 'Confirmed',
  [lngStatus.processing]: 'Processing',
  [lngStatus.shipping]: 'Shipping',
  [lngStatus.delivered]: 'Delivered',
  [lngStatus.completed]: 'Completed',
  [lngStatus.cancelled]: 'Cancelled',
  [lngStatus.onHold]: 'On Hold',
  [lngStatus.returned]: 'Returned',
  [lngStatus.refunded]: 'Refunded',
  [lngStatus.failed]: 'Failed',
  [lngStatus.awaitingPayment]: 'Awaiting Payment',
  [lngStatus.partiallyShipped]: 'Partially Shipped',
  [lngStatus.backordered]: 'Backordered',
  [lngStatus.awaitingFulfillment]: 'Awaiting Fulfillment',
};

const itemTokens = {
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.nav.academy]: 'Academy',
  [tokens.nav.account]: 'Account',
  [tokens.nav.analytics]: 'Analytics',
  [tokens.nav.auth]: 'Auth',
  [tokens.nav.blog]: 'Blog',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.calendar]: 'Calendar',
  [tokens.nav.chat]: 'Chat',
  [tokens.nav.checkout]: 'Checkout',
  [tokens.nav.concepts]: 'Concepts',
  [tokens.nav.contact]: 'Contact',
  [tokens.nav.course]: 'Course',
  [tokens.nav.create]: 'Create',
  [tokens.nav.crypto]: 'Crypto',
  [tokens.nav.customers]: 'Customers',
  [tokens.nav.teachers]: 'Teachers',
  [tokens.nav.students]: 'Students',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.details]: 'Details',
  [tokens.nav.ecommerce]: 'E-Commerce',
  [tokens.nav.edit]: 'Edit',
  [tokens.nav.error]: 'Error',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'File Manager',
  [tokens.nav.finance]: 'Finance',
  [tokens.nav.fleet]: 'Fleet',
  [tokens.nav.forgotPassword]: 'Forgot Password',
  [tokens.nav.invoiceList]: 'Invoices',
  [tokens.nav.jobList]: 'Job Listings',
  [tokens.nav.kanban]: 'Kanban',
  [tokens.nav.list]: 'List',
  [tokens.nav.login]: 'Login',
  [tokens.nav.logistics]: 'Logistics',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Management',
  [tokens.nav.orderList]: 'Orders',
  [tokens.nav.overview]: 'Overview',
  [tokens.nav.pages]: 'Pages',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.productList]: 'Products',
  [tokens.nav.profile]: 'Profile',
  [tokens.nav.register]: 'Register',
  [tokens.nav.resetPassword]: 'Reset Password',
  [tokens.nav.socialMedia]: 'Social Media',
  [tokens.nav.verifyCode]: 'Verify Code',
  [tokens.nav.payroll]: 'Payroll',
  [tokens.nav.payslip]: 'Payslip',
  [tokens.nav.fuel]: 'Fuel',
  [tokens.nav.repair]: 'Car repair',
  [tokens.nav.tms]: 'Check In/Out',
  [tokens.nav.car]: 'Car',
  [tokens.nav.partner]: 'Partner',
  [tokens.nav.staff]: 'Staff',
  [tokens.nav.workSchedule]: 'Schedule',
  [tokens.nav.repairRequest]: 'Repair Request',
  [tokens.nav.carManagement]: 'Car Management',
  [tokens.nav.groups]: 'Group',
  [tokens.nav.repairSchedule]: 'Repair Schedule',
  [tokens.nav.demo]: 'Basic Demo',
};

const itemSlot = {
  [lngSlot.morning]: 'Morning',
  [lngSlot.evening]: 'Evening',
  [lngSlot.night]: 'Night',
};

const itemAppStr = {
  [appStr.txt_001]: 'Search',
  // TODO continue handle more
};

const itemAssistant = {
  ['search_tooltip']: 'How to use more than search options',
};

const itemSearch = {
  ['bill']: 'Bill',
  ['code']: 'Code',
  ['card']: 'Card',
  ['date']: 'Date',
  ['name']: 'Name',
  ['phone']: 'Phone',
  ['plate']: 'Plate',
  ['place']: 'Place',
};

export const en = {
  ...itemRole,
  ...itemStatus,
  ...itemTokens,
  ...itemSlot,
  ...itemAppStr,
  ...itemAssistant,
  ...itemSearch,

  ['OOPS']: 'Oops, Something went wrong',
  ['ECS_x']: 'Error code from Server',
  ['coming_soon']: 'Coming soon',
};
